class FairwindCreations extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const trigger = this.querySelector('.fw-creations__film');
    const dialog = this.querySelector('.fw-creations__film-dialog');
    const video = this.querySelector('video');
    if (!trigger || !dialog || !video) return;
    this.dialog = dialog;
    this.video = video;
    trigger.addEventListener('click', () => {
      if (dialog.open) return;
      dialog.showModal();
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      // A blocked play request leaves the native controls available.
      video.play().catch(() => {});
    }, { signal });
    this.querySelector('.fw-creations__film-close').addEventListener('click', () => dialog.close(), { signal });
    let backdropPress = false;
    const outside = event => {
      const box = dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    };
    dialog.addEventListener('pointerdown', event => { backdropPress = event.target === dialog && outside(event); }, { signal });
    dialog.addEventListener('click', event => {
      if (backdropPress && event.target === dialog && outside(event)) dialog.close();
      backdropPress = false;
    }, { signal });
    dialog.addEventListener('close', () => {
      video.pause();
      if (video.readyState > 0) video.currentTime = 0;
      trigger.focus({ preventScroll: true });
    }, { signal });
    video.addEventListener('error', () => {
      this.querySelector('.fw-creations__film-error').hidden = false;
    }, { signal });
  }

  disconnectedCallback() {
    this.video?.pause();
    if (this.dialog?.open) this.dialog.close();
    this.controller?.abort();
  }
}

if (!customElements.get('fairwind-creations')) {
  customElements.define('fairwind-creations', FairwindCreations);
}
